import { useForm } from 'react-hook-form';
import {
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import {
  TextInput,
  PhoneInput,
  SelectInput,
} from '~/shared/components/form/Inputs';
import { stateOptions } from '~/shared/config';
import checkImg from '~/shared/img/check_image.png';

const DirectDeposit = () => {
  const { control } = useForm({
    defaultValues: {
      client_name: '',
      payee_name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      bank_name: '',
      bank_routing_number: '',
      bank_account_number: '',
      voided_check: '',
      letter_screenshot: '',
    },
  });

  return (
    <div className='container__inner pb-5'>
      <Row className='mb-4'>
        <Col xl={6}>
          <h1 className='h2'>Direct Deposit</h1>
          <Badge color='success' className='me-3'>
            Submitted
          </Badge>
          <span className='text-muted'>Last Updated 00/00/00</span>
        </Col>
        <Col xl={6} className='d-flex justify-content-xl-end align-items-start'>
          <Button color='outline-dark'>Cancel</Button>
          <Button color='primary'>Submit</Button>
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col lg={6}>
          <Card className='border'>
            <CardBody>
              <h4>Payee Information</h4>
              <TextInput
                label='Client Name'
                name='client_name'
                control={control}
                required
                disabled={true}
              />
              <FormGroup check className='mb-2'>
                <Label check>
                  <Input
                    type='checkbox'
                    name='clientPayOption'
                    value='payee_is_client'
                  />
                  Payee is Client
                </Label>
              </FormGroup>
              <TextInput
                label='Payee Name'
                name='payee_name'
                control={control}
                required
              />
              <PhoneInput
                label='Phone'
                control={control}
                name='phone'
                required
              />
              <TextInput
                label='Email'
                control={control}
                name='email'
                type='email'
                required
              />
              <TextInput
                label='Street Address 1'
                control={control}
                name='address1'
                required
              />
              <TextInput
                label='Street Address 2'
                control={control}
                name='address2'
              />
              <TextInput label='City' name='city' control={control} required />

              <div style={{ display: 'flex', width: '100%' }}>
                <span style={{ width: '75%', marginRight: '10px' }}>
                  <SelectInput
                    label='State'
                    control={control}
                    name='state'
                    options={stateOptions}
                    required
                  />
                </span>
                <span style={{ width: '25%' }}>
                  <TextInput
                    label='Zip Code'
                    control={control}
                    name='zip'
                    required
                  />
                </span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col lg={6}>
          <Card className='border'>
            <CardBody>
              <h4>Bank Information</h4>
              <TextInput
                label='Bank Name'
                name='bank_name'
                control={control}
                required
              />
              <TextInput
                label='Street Address 1'
                control={control}
                name='address1'
                required
              />
              <TextInput
                label='Street Address 2'
                control={control}
                name='address2'
              />
              <TextInput label='City' name='city' control={control} required />

              <div style={{ display: 'flex', width: '100%' }}>
                <span style={{ width: '75%', marginRight: '10px' }}>
                  <SelectInput
                    label='State'
                    control={control}
                    name='state'
                    options={stateOptions}
                    required
                  />
                </span>
                <span style={{ width: '25%' }}>
                  <TextInput
                    label='Zip Code'
                    control={control}
                    name='zip'
                    required
                  />
                </span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col>
          <Card className='border'>
            <CardBody>
              <h4>Account Information</h4>
              <Row>
                <Col lg={6}>
                  <TextInput
                    label='Bank Routing Number'
                    name='bank_routing_number'
                    control={control}
                    required
                  />
                  <TextInput
                    label='Bank Account Number'
                    control={control}
                    name='bank_account_number'
                    required
                  />
                  <Label>
                    I will be providing one of the following:{' '}
                    <span className='required'>*</span>
                  </Label>
                  <FormGroup check className='mb-2'>
                    <Label check>
                      <Input
                        type='radio'
                        name='clientPayOption'
                        value='voided_check'
                      />
                      A voided check
                    </Label>
                  </FormGroup>
                  <FormGroup check className='mb-2'>
                    <Label check>
                      <Input
                        type='radio'
                        name='clientPayOption'
                        value='letter_screenshot'
                      />
                      Letter or screenshot from bank stating account and routing
                      number
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label>Upload File</Label>
                    <Input type='file' name='uploade_file' />
                    <small className='form-text text-muted'>
                      Should not exceed a certain size and only certain file
                      types are accepted.
                    </small>
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <img src={checkImg} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col lg={8}>
          <Card className='border'>
            <CardBody>
              <h4>Terms and conditions for direct deposit payments</h4>
              <ol>
                <li className='mb-3'>
                  The electronic funds transfer will be made to the financial
                  institution and account listed on this form.
                </li>
                <li className='mb-3'>
                  <strong>
                    The information on this form is very important
                  </strong>
                  . Payee understands that any change in the information
                  provided must be communicated by an authorized representative
                  of Payee in writing to Help Hope Live in time to allow us to
                  respond to the change.{' '}
                  <strong>
                    Payee expressly agrees to indemnify and hold harmless Help
                    Hope Live from any loss that may arise by reason of error,
                    mistake or fraud relating to the information Payee has
                    provided
                  </strong>
                  .
                </li>
                <li className='mb-3'>
                  Help Hope Live has the right to adjust future payments if
                  payments made are found to be duplicates, in excess of
                  requirements, fraudulently induced, or otherwise in error.
                </li>
                <li className='mb-3'>
                  In the event that Help Hope Live or a banking institution is
                  notified that funds have been deposited to payee's banking
                  account in error, payee authorizes the applicable banking
                  institution to return such funds to HelpHope Live.
                </li>
              </ol>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Button color='outline-dark'>Cancel</Button>
      <Button color='primary'>Submit</Button>
    </div>
  );
};

export default DirectDeposit;
